import { createApi } from '@reduxjs/toolkit/query/react';
import { getBaseQuery } from './getBaseQuery';
import { GetStudiedPhaseRequest, GetStudiedPhaseResponse } from './types/TStudiedPhase';

const URL_Prefix = '/studied_phase';

export const studiedPhaseService = createApi({
    reducerPath: 'studiedPhaseService',
    baseQuery: getBaseQuery,
    tagTypes: ['StudiedPhase'],
    endpoints: (builder) => ({
        getStudiedPhase: builder.query<GetStudiedPhaseResponse, GetStudiedPhaseRequest>({
            query: (params) => ({
                url: `${URL_Prefix}/selector/`,
                method: 'GET',
            }),
        }),
    }),
});

export const {
    useGetStudiedPhaseQuery,
    useLazyGetStudiedPhaseQuery
} = studiedPhaseService;